<template>
  <div
    data-qa-id="font-style-item"
    class="font-style-item is-flex is-flex--justify-between"
    :class="{ active: style?.isFontStyleAdded }"
  >
    <div class="flex-1">
      {{ style.styleName }}
    </div>
    <div
      v-if="style?.isFontStyleAdded"
      data-qa-id="tick-icon"
      class="cursor-pointer"
    >
      <button @click="updateAddFont(family.familyId, style.styleId)">
        <TickIcon />
      </button>
    </div>
    <div
      v-else
      data-qa-id="plus-wrapper"
      class="cursor-pointer fou-font-add-btn"
      @click="addFontToBundle(family, sku.skuId, style)"
    >
      <Plus />
    </div>
  </div>
</template>

<script src="./index" />

<style lang="scss">
@import 'mpl-css/lib/assets/global/variables/colors';
@import 'mpl-css/lib/assets/global/functions/index';

.font-style-item {
  background: map-get($colors, 'spirits--25');
  padding: rem(16) rem(24);
  gap: rem(4);

  &:not(:last-of-type) {
    border-bottom: 1px solid map-get($colors, 'spirits--300');
  }
  &.active {
    background: map-get($colors, 'turtle-green--25');
  }
}
</style>
